import { render, staticRenderFns } from "./RevenueAdd.vue?vue&type=template&id=6a0cae24&scoped=true&"
import script from "./RevenueAdd.vue?vue&type=script&lang=js&"
export * from "./RevenueAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0cae24",
  null
  
)

export default component.exports